import supabase from '../supabaseClient';

// Fetch all reactions for a post
export async function fetchReactions(postId) {
  const { data, error } = await supabase
    .from('post_reactions')
    .select('user_id, reaction_type')
    .eq('post_id', postId);
  if (error) throw error;
  return data;
}

// Add or update a reaction for the current user
export async function upsertReaction(postId, reactionType, userId) {
  // Upsert: if exists, update; else, insert
  const { data, error } = await supabase
    .from('post_reactions')
    .upsert([
      { post_id: postId, user_id: userId, reaction_type: reactionType }
    ], { onConflict: ['post_id', 'user_id'] });
  if (error) throw error;
  return data;
}

// Remove a reaction for the current user
export async function removeReaction(postId, userId) {
  const { error } = await supabase
    .from('post_reactions')
    .delete()
    .eq('post_id', postId)
    .eq('user_id', userId);
  if (error) throw error;
}